<template>
  <div>
    <!-- <img :src="currentImg" alt=""/> -->
    <div class="image-wrapper" ref="el-image-viewer__wrapper">

      <div class="image-mask"></div>
      <div class="image-close-button" @click="hide">
        <i class="el-icon-close"></i>
      </div>
      <div class="image-viewer-small_prewlist">
        <div class="small-viewer_current" :class="[index===y?'active-img':'']" v-for="(item,y) in urlList" :key="y" @click="changeIndex(y)">
          <img :src="item" alt="">
        </div>
      </div>
      <div class="el-image-viewer__canvas">
        <div class="image-viewer__btn image-viewer_pre" @click="prev()"  v-if="!isSingle&&showButton">
          <i class="el-icon-arrow-left"></i>
        </div>
        <template v-for="(url,i) in urlList">
          <img v-if="i === index" ref="img" :key="i" class="image-viewer__img" :src="currentImg" :style="imgStyle" @load="handleImgLoad"/>
          <!-- @load="handleImgLoad" @error="handleImgError" @mousedown="handleMouseDown" -->
        </template>
        <div class="image-viewer__btn image-viewer_next" @click="next()"  v-if="!isSingle&&showButton">
          <i class="el-icon-arrow-right"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    urlList: {
      type: Array,
      default: () => []
    },
    zIndex: {
      type: Number,
      default: 2000
    },
    onSwitch: {
      type: Function,
      default: () => { }
    },
    onClose: {
      type: Function,
      default: () => { }
    },
    initialIndex: {
      type: Number,
      default: 0
    },
    appendToBody: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      transform: {
        scale: 1,
        deg: 0,
        offsetX: 0,
        offsetY: 0,
        enableTransition: false
      },
      showButton: false,
      loading: false,
      infinite: true,
      index: this.initialIndex
    }
  },
  watch: {
    index: {
      handler: function(val) {
        this.reset()
        this.onSwitch(val)
      }
    },
    currentImg(val) {
      this.$nextTick(_ => {
        const $img = this.$refs.img[0]
        if (!$img.complete) {
          this.loading = true
        }
      })
    }
  },
  mounted() {
    if (this.appendToBody) {
      document.body.appendChild(this.$el)
    }
    this.$refs['el-image-viewer__wrapper'].focus()
  },
  destroyed() {
    // if appendToBody is true, remove DOM node after destroy
    if (this.appendToBody && this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el)
    }
  },
  computed: {
    currentImg() {
      return this.urlList[this.index]
    },
    isSingle() {
      return this.urlList.length <= 1
    },
    isFirst() {
      return this.index === 0
    },
    isLast() {
      return this.index === this.urlList.length - 1
    },
    imgStyle() {
      const { scale, deg, offsetX, offsetY, enableTransition } = this.transform
      const style = {
        transform: `scale(${scale}) rotate(${deg}deg)`,
        transition: enableTransition ? 'transform .3s' : '',
        'margin-left': `${offsetX}px`,
        'margin-top': `${offsetY}px`
      }
      // if (this.mode === Mode.CONTAIN) {
      //   style.maxWidth = style.maxHeight = '100%'
      // }
      return style
    }
  },
  methods: {
    handleImgLoad(e) {
      this.loading = false
      this.showButton = true
    },
    reset() {
      this.transform = {
        scale: 1,
        deg: 0,
        offsetX: 0,
        offsetY: 0,
        enableTransition: false
      }
    },
    hide() {
      this.onClose()
    },
    prev() {
      if (this.isFirst && !this.infinite) return
      const len = this.urlList.length
      this.index = (this.index - 1 + len) % len
    },
    next() {
      if (this.isLast && !this.infinite) return
      const len = this.urlList.length
      this.index = (this.index + 1) % len
    },
    test() {
      console.log(111)
    },
    changeIndex(index) {
      this.index = index
    }
  }
}
</script>

<style lang="scss" scoped>
.image-wrapper {
  z-index: 2000;
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0px;
  top: 0px;
  .image-mask {
    position: absolute;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.8);
    width: 100%;
    height: 100%;
    overflow: hidden;
  }
  .image-close-button {
    top: 40px;
    right: 40px;
    width: 40px;
    height: 40px;
    font-size: 24px;
    color: #fff;
    background-color: #606266;
    position: absolute;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    opacity: 0.8;
    cursor: pointer;
    box-sizing: border-box;
    width: 60px;
    height: 60px;
    font-size: 30px;
  }
  .image-viewer__btn {
    // position: absolute;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    opacity: 0.8;
    cursor: pointer;
    box-sizing: border-box;
    user-select: none;
  }
  .image-viewer_pre {
    top: 50%;
    transform: translateY(-50%);
    width: 60px;
    height: 60px;
    font-size: 30px;
    color: #fff;
    background-color: #606266;
    border-color: #fff;
    // left: 160px;
    margin-right: 40px;
  }
  .image-viewer_next {
    top: 50%;
    transform: translateY(-50%);
    width: 60px;
    height: 60px;
    font-size: 30px;
    color: #fff;
    background-color: #606266;
    border-color: #fff;
    right: 160px;
    margin-left: 40px;
  }
  .image-viewer-small_prewlist {
    position: absolute;
    left: 3%;
    top: 52px;
    max-height: 80%;
    overflow: auto;
    padding-right: 5px;
    .small-viewer_current {
      width: 80px;
      height: 80px;
      box-sizing: border-box;
      border: 0.5px solid #cdd4dd;
      border-radius: 4px;
      margin-bottom: 15px;
      img {
        width: 100%;
        height: 100%;
        border-radius: 4px;
        object-fit: cover;
        overflow: hidden;
      }
    }
  }
  .image-viewer-small_prewlist::-webkit-scrollbar {
    width: 2px;
    height: 5px;
  }
  .image-viewer-small_prewlist::-webkit-scrollbar-track {
    background: none;
  }
  .el-image-viewer__canvas {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .image-viewer__img {
    height: 100%;
    transform: scale(1) rotate(0deg);
    margin-left: 0px;
    margin-top: 0px;
    object-fit: contain;
  }
  .active-img {
    border: 2px solid #99c41c !important;
  }
}
</style>
